export default __webpack_public_path__ + "static/media/logo-impact-sdg17.fc6f7d95.svg";